import React from 'react';
import { useT } from '@hooks';
import { appStore } from '@store';
import styled from 'styled-components';
import { Title } from '../title';
import { METRICS } from '@types';

import male from './img/male.png';
import female from './img/female.png';
import female_webp from './img/female.webp';

const Container = styled.div`
	width: 100%;
`;

const Wrapper = styled.div`
	border-radius: 5px;
	background: ${({ theme }) => theme.colors.bg12};
	width: 100%;
	padding: 6px 6px 20px 6px;
	margin-top: 16px;
`;

const ImgWrapper = styled.div`
	border-radius: 5px;
	width: 100%;
	position: relative;
	overflow: hidden;

	img {
		width: 100%;
	}
`;

const Label = styled.p`
	color: ${({ theme }) => theme.colors.text11};
	font-size: 12px;
	font-weight: 800;
	line-height: 14px;
	width: calc(100% - 20px);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 13px 10px;
	border-radius: 5px;
	background: ${({ theme }) => theme.colors.bg1};
	box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
	position: absolute;
	bottom: 10px;
	left: 10px;

	span {
		color: ${({ theme }) => theme.colors.text26};
	}
`;

const Description = styled.p`
	color: ${({ theme }) => theme.colors.text11};
	font-size: 12px;
	font-weight: 500;
	line-height: 15px;
	text-align: left;
	padding: 0 10px;
	margin-top: 12px;
`;

export const BeforeAfter = () => {
	const { T } = useT();
	const { unitsStore } = appStore;
	const gender = appStore.params.gender;
	const units = unitsStore.isMetrics ? METRICS.KG : METRICS.LBS;

	return (
		<Container>
			<Title>Result that make us proud</Title>
			<Wrapper>
				<ImgWrapper>
					{gender === 'male' ? (
						<picture>
							<source srcSet={male} type='image/webp' />
							<img src={male} alt='before' />
						</picture>
					) : (
						<picture>
							<source srcSet={female_webp} type='image/webp' />
							<img src={female} alt='before' />
						</picture>
					)}
					<Label>
						Lisa,<span>&nbsp;{unitsStore.isMetrics ? '-15 kg' : '-30 lbs'}</span>
					</Label>
				</ImgWrapper>
				<Description>
					For a long time I wasn't able to maintain healthy weight long-term. I'd lose some pounds
					but then l'd get like a double back. I was not in the best place. Not until I found this
					app. It's far more than just a weight loss app, it's a change in lifestyle.
				</Description>
			</Wrapper>
		</Container>
	);
};
